// src/utils/useEnlaceExterno.js
import { useCallback } from 'react';
import Swal from 'sweetalert2';

/**
 * Hook reutilizable: intercepta clics en enlaces externos y pide confirmación
 * antes de sacar al usuario de la plataforma SINTEREC.
 *
 * Uso:
 *   const onClickContenido = useEnlaceExterno();
 *   <div onClick={onClickContenido} dangerouslySetInnerHTML={{ __html: htmlSeguro }} />
 *
 * No es un "middleware global" (React no tiene eso para clics); es un handler
 * que reutilizas en cualquier contenedor que muestre HTML con enlaces.
 */
export default function useEnlaceExterno(dominioPropio = 'sinterec.cl') {
  return useCallback(
    (e) => {
      const target = e.target.closest('a');
      if (!target) return;

      const href = target.getAttribute('href') || '';
      const esExterno = /^https?:\/\//i.test(href) && !href.includes(dominioPropio);

      if (esExterno) {
        e.preventDefault();
        Swal.fire({
          title: 'Enlace externo',
          html: `Estás por salir de la plataforma SINTEREC hacia:<br><br><strong style="word-break:break-all">${href}</strong><br><br>¿Deseas continuar?`,
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#d0021b',
          cancelButtonColor: '#6c757d',
          confirmButtonText: 'Sí, continuar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
        }).then((r) => {
          if (r.isConfirmed) {
            window.open(href, '_blank', 'noopener,noreferrer');
          }
        });
      }
      // Los enlaces internos (mismo dominio) siguen su comportamiento normal.
    },
    [dominioPropio]
  );
}